import { BillStatus } from '@invenco/common-interface/accounts';

import type { BillsQueryQuery } from '@/graphql/generated/platform/graphql';
import { convertDateTimeToISO, getEnumValue } from '@/shared/helpers';
import { ListData } from '@/shared/types';

type BillHold = NonNullable<NonNullable<BillsQueryQuery['bills']>[number]['holds']>[number];

export type BillListItem = {
  id: string;
  name?: string;
  accountName?: string;
  locationName?: string;
  status?: BillStatus;
  periodStart: string;
  periodEnd: string;
  recalculatedAt?: string;
  billTotal: number;
  holds: BillHold[];
};

export class BillListMapper {
  private static getRecalculatedAt(rawValue: string | null | undefined) {
    if (!rawValue) return undefined;
    const isoRecalculatedAt = convertDateTimeToISO(rawValue);
    return isoRecalculatedAt === '1970-01-01T00:00:00.000Z' ? undefined : isoRecalculatedAt;
  }

  static toData(response: BillsQueryQuery): ListData<BillListItem> {
    const total = response?.billsAggregate?._count ?? 0;
    const data = Array.isArray(response.bills)
      ? response.bills.map((bill) => ({
          id: bill.id,
          name: bill.name || undefined,
          accountName: bill.account?.name || undefined,
          locationName: bill.location?.name || undefined,
          status: getEnumValue(BillStatus, bill.status),
          periodStart: bill.periodStart,
          periodEnd: bill.periodEnd,
          recalculatedAt: BillListMapper.getRecalculatedAt(bill.recalculatedAt),
          billTotal: bill.billTotal,
          holds: bill.holds ?? [],
        }))
      : [];

    return { data, total };
  }
}
